module.exports = __webpack_public_path__ + "img/sprites.8f7c2e2b.svg";